module.exports = __webpack_public_path__ + "img/ic_forum.0931c4a1.svg";